import React, { useState } from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { MessageInput } from '@/components/cases/ai-assistant/MessageInput';
import { Message } from '@/types/chat';
import { HelpMessage } from './HelpMessage';
import { QuickSuggestions } from './QuickSuggestions';

interface HelpAssistantChatProps {
  messages: Message[];
  isLoading: boolean;
  onSendMessage: (message: string) => void;
}

export function HelpAssistantChat({ messages, isLoading, onSendMessage }: HelpAssistantChatProps) {
  const [input, setInput] = useState('');

  const handleSend = () => {
    if (input.trim()) {
      onSendMessage(input);
      setInput('');
    }
  };

  return (
    <div className="flex flex-col h-[calc(100vh-8rem)] gap-4">
      <ScrollArea className="flex-1 pr-4">
        {messages.map((message) => (
          <HelpMessage key={message.id} message={message} />
        ))}
      </ScrollArea>
      
      <QuickSuggestions onSelect={(suggestion) => {
        onSendMessage(suggestion);
      }} />

      <MessageInput
        value={input}
        onChange={setInput}
        onSend={handleSend}
        isLoading={isLoading}
        placeholder="Skriv din melding her..."
      />
    </div>
  );
}